<div class="dev-bar">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="col-auto">
                <nb-icon icon="hash-outline" class="mr-2"></nb-icon>
                <span>ambiente de desenvolvimento</span>
                <hr class="divider vertical" />
            </div>
            <div class="col-8 col-lg-5">
                <div class="host-selector">
                    <label class="label">Mudar Host</label>
                    <nb-select size="tiny" placeholder="Host selecionado" fullWidth [(ngModel)]="host">
                        <nb-option *ngFor="let host of tokenService.availableHosts" [value]="host">{{
                            host
                        }}</nb-option>
                    </nb-select>
                    <button nbButton size="tiny" class="ml-2" status="primary" (click)="changeHost()">Mudar</button>
                </div>
            </div>
        </div>
    </div>
</div>
